"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GraphQLBackgrounds = exports.GraphQLColors = void 0;
const Colors_1 = require("../Colors");
exports.GraphQLColors = {
    type: Colors_1.Colors.main[0],
    union: Colors_1.Colors.main[0],
    input: Colors_1.Colors.blue[0],
    scalar: Colors_1.Colors.green[0],
    interface: Colors_1.Colors.sky[0],
    enum: Colors_1.Colors.yellow[0],
    directive: Colors_1.Colors.pink[0],
    extend: Colors_1.Colors.orange[0],
    String: Colors_1.Colors.green[0],
    Int: Colors_1.Colors.green[0],
    Boolean: Colors_1.Colors.green[0],
    ID: Colors_1.Colors.green[0],
    Float: Colors_1.Colors.green[0],
};
exports.GraphQLBackgrounds = {
    type: Colors_1.Colors.main[6],
    union: Colors_1.Colors.main[7],
    input: Colors_1.Colors.blue[6],
    scalar: Colors_1.Colors.green[6],
    interface: Colors_1.Colors.sky[6],
    enum: Colors_1.Colors.yellow[6],
    directive: Colors_1.Colors.pink[6],
    extend: Colors_1.Colors.orange[6],
    Extend: Colors_1.Colors.orange[6],
    String: Colors_1.Colors.green[6],
    Int: Colors_1.Colors.green[6],
    Boolean: Colors_1.Colors.green[6],
    ID: Colors_1.Colors.green[6],
    Float: Colors_1.Colors.green[6],
};
